import React, { useState } from 'react';

const mockHistory = [
  {
    id: 1,
    algorithm: 'SPTNet',
    date: '2025-06-03 14:35',
    status: '✅ Completed',
    logPath: '/placeholders/training_log.txt',
    videoPath: '/placeholders/preview.mp4',
  },
  {
    id: 2,
    algorithm: 'TrackMate',
    date: '2025-06-01 10:12',
    status: '⏳ Running',
    logPath: '',
    videoPath: '',
  },
];

const HistoryPage = () => {
  const [records, setRecords] = useState(mockHistory);

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-3xl font-bold">🕓 Training History</h1>
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-200 text-left">
            <th className="p-2">Algorithm</th>
            <th className="p-2">Date</th>
            <th className="p-2">Status</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {records.map((rec) => (
            <tr key={rec.id} className="border-t">
              <td className="p-2">{rec.algorithm}</td>
              <td className="p-2">{rec.date}</td>
              <td className="p-2">{rec.status}</td>
              <td className="p-2 space-x-2">
                {rec.videoPath && (
                  <a
                    href={rec.videoPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    🎞️ Video
                  </a>
                )}
                {rec.logPath && (
                  <a
                    href={rec.logPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-600 hover:underline"
                  >
                    📈 Logs
                  </a>
                )}
                <button
                  onClick={() => setRecords(records.filter(r => r.id !== rec.id))}
                  className="text-red-500 hover:underline"
                >
                  🗑️ Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistoryPage;
